import {
  PRODUCT_LIST,
  PRODUCT_LIST_START,
  PRODUCT_SET,
} from "../constants/actionTypes";
import { Product } from "../types/product";

function doListProducts() {
  return { type: PRODUCT_LIST };
}

const doListProductsStart = () => {
  return { type: PRODUCT_LIST_START };
};

const doSetProducts = (products: Product[]) => ({
  type: PRODUCT_SET,
  payload: products,
});

export { doListProducts, doListProductsStart, doSetProducts };
